<template>
	<!-- Navbar start -->
	<navbar-element></navbar-element>
	<!-- Navbar end -->

	<!-- Rendered view start -->
	<!-- Rendered view end -->

	<!-- Footer start -->
	<!-- Footer end -->

	<router-view></router-view>
	<footer-element></footer-element>

</template>

<script>
import NavbarElement from '@/components/NavbarElement.vue';
import FooterElement from '@/components/FooterElement.vue';

export default {
	components: {
		FooterElement,
		NavbarElement
	},
	mounted() {
		const usersLanguage = window.navigator.language
		const availibleLocales = this.$i18n.availableLocales;
		console.log("availibleLocales: ", availibleLocales)
		console.log("usersLanguage: ", usersLanguage);

		if (availibleLocales.includes(usersLanguage)) {
			this.$i18n.locale = usersLanguage;
		} else {
			this.$i18n.locale = 'en';
		}
	}
}
</script>

<style>
html {
	padding-right: 0px !important;
	margin-right: 0px !important;
}
body {
	padding-right: 0px !important;
	margin-right: 0px !important;
}

html, body {
    overflow-x: hidden;
}
</style>
